import { useLayoutEffect } from "react";

import { useClearSessionMessages } from "./use-clear-session-messages";

let lastOrganizationCode = "";

export function forgetLastOrganization() {
  lastOrganizationCode = "";
}

export function useClearOnOrganizationChange(organizationCode: string) {
  const clearSessionMessages = useClearSessionMessages();

  useLayoutEffect(() => {
    if (!organizationCode) return;
    const previousOrganizationCode = lastOrganizationCode;
    lastOrganizationCode = organizationCode;
    if (
      previousOrganizationCode &&
      previousOrganizationCode !== organizationCode
    ) {
      clearSessionMessages();
    }
  }, [organizationCode, clearSessionMessages]);
}
